import {UploadedFile} from '@interfaces/file.interface';

export namespace SpecialistInterfaces {

    /**
     * Допуск/Разрешение
     */
    export interface Permit {
        /**
         * Поля, принадлежащие форме
         */
        type: number;           // Тип документа (id)
        number: string;         // Номер документа
        date: string;           // Дата выдачи
        date_end: string;       // Дата окончания
        grade: number|string;   // Группа допуска
        issued_by: string;      // Образовательно учреждение (кем выдано)
        files: UploadedFile[];  // Файлы копий документов


        /**
         * Вычисляемые поля для отображения
         */
        is_expired: boolean;     // Просрочено или нет (проверяется дата окончания, если она есть)
        type_title?: string;     // Заголовок типа документа/допуска/разрешения
        grade_title?: string;    // Наименование группы (в каких-то документах это число, в каких-то римска цифра)

    }
}



export namespace SpecialistEnums {
    /**
     * Статус работы сотрудника
     */
    export enum Status {
        working = 1,    // Работает
        out = 2,        // В отпуске или на больничном
        fired = 3,      // Уволен
    }

    /**
     * Тип допуска/разрешения
     */
    export enum PermitType {
        fireTechMin = 1,                        // Пожарно технический минимум
        workingOnHigh = 2,                      // Работа на высоте
        labourProtection = 3,                   // Охрана труда
        electrosecurityLabourProtection = 4,    // Аттестации по ОТ по электробезопасности
        electrosecurityAccess = 5,              // Допуски по электробезопасности
        radiationSafety = 6,                    // Знания радиационной безопасности
        liftWorker = 7,                         // Рабочий люльки подъёмника (вышки)
    }
}
